import React, { useEffect, useState} from 'react';
import { Button } from 'semantic-ui-react';
import GConf from '../AssetsM/generalConf';
import { Menu, Tab } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import axios from 'axios';
import TableGrid from '../AssetsM/tableaux';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { _ } from "gridjs-react";
import { useNavigate} from 'react-router-dom';

import AddProffCard from './addProff';
import AddEtudiantCard from './addEtudiant';

import { Area, AreaChart, Bar, BarChart, Cell, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import FrameForPrint from './frameForPrint';
 

function EtudiantLandingPage() {
    /*#########################[Const]###########################*/
    const navigate = useNavigate();
    let AdminData = JSON.parse(localStorage.getItem("AdminData"));
    const inputIsLogged = JSON.parse(localStorage.getItem('AdminData'));

    let [profListe, setProfListe] = useState([])
    let [etudiantListe, setEtudiantListe] = useState([])
    let [seancesListe, setSeanceListe] = useState([])
    
    const COLORS = ['#ce2085','#0088FE', '#00C49F', '#FFBB28'];
    let [evolutionSChart, setEvolutionChart] = useState([])
    let [matiereChart, setMatiereChart] = useState([])
    let [groupeChart, setGroupeChart] = useState([])
    let [seanceData, setSeanceData] = useState([])

    
    const [activeIndex, setActiveIndex] = useState(0)
    const [sheetActiveIndex, setSheetActiveIndex] = useState('')
    const [openD, setOpenD] = useState(false)

    const panesRes = [
      {
        menuItem: { key: 'attent',  content: <span className='text-warning'><b><span className='bi bi-hourglass-split'></span> En Attent</b></span> , className:'rounded-pill'},
        render: () => <StatCard />,
      },
      {
        menuItem: { key: 'vu',  content: <span className='text-warning'><b><span className='bi bi-hourglass-split'></span> En Attent</b></span> , className:'rounded-pill'},
        render: () => <div><ProffListeCard /> </div>,
      },
       {
        menuItem: { key: 'accept',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div> <EtudiantListeCard /> </div>,
      },
      {
        menuItem: { key: 'accept',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div><SeancesListeCard /> </div>,
      },
      {
        menuItem: { key: 'pr',  content: <span className='text-success'><b><span className='bi bi-check-square-fill'></span> Accepteé</b></span> , className:'rounded-pill' },
        render: () => <div>Profile  
            <div className='col-2 align-self-center' ><Button onClick={logOutInput} style={{backgroundColor:GConf.themeColor}} className='rounded text-white' icon='log out' >Deconnextion</Button>  </div>

        </div>,
      },
       
    ]

    /*#########################[UseEffect]###########################*/
    useEffect(() => {
        const inputIsLogged = JSON.parse(localStorage.getItem('AdminData'));
        if (!inputIsLogged) {window.location.href = "/Admin/logIn";}
         
        axios.post(`${GConf.ApiLink}/proff/select-list`, {
            p_email : 0 ,
            idp : 1
        })
        .then(function (response) {
            let pl = [];
            response.data.map((data,index) => pl.push([
                  data.idp,
                  data.p_nom,
                  data.p_email,
                  data.p_matiere,
               _(<Button className='rounded-pill bg-danger text-white' size='mini' onClick={ (e) => OpenBottomSheetFunction('Edit')}><span className='bi bi-trash'></span> </Button>),
               _(<Button className='rounded-pill bg-primary text-white' size='mini' onClick={ (e) => OpenBottomSheetFunction('Edit')}><span className='bi bi-pen'></span> </Button>),
               _(<Button className='rounded-pill bg-secondary text-white' size='mini' onClick={ (e) => navigate(`addemp/${data.idp}`)}><span className='bi bi-table'></span> </Button>),
            ],))
            setProfListe(pl)
        })

        axios.post(`${GConf.ApiLink}/etudiant/select-list`, {
            p_email : 0 ,
            idp : 1
        })
        .then(function (response) {
            let el = [];
            response.data.map((data,index) => el.push([
                  data.ide,
                  data.e_nom,
                  data.e_email,
                  data.e_groupe,
               _(<Button className='rounded-pill bg-danger text-white' size='mini' onClick={ (e) => OpenBottomSheetFunction('Edit')}><span className='bi bi-trash'></span> </Button>),
               _(<Button className='rounded-pill bg-primary text-white' size='mini' onClick={ (e) => OpenBottomSheetFunction('Edit')}><span className='bi bi-pen'></span> </Button>),
              //  _(<Button className='rounded-pill bg-secondary text-white' size='mini' onClick={ (e) => navigate('addemp')}><span className='bi bi-table'></span> </Button>),
            ],))
            setEtudiantListe(el)
        })

        axios.post(`${GConf.ApiLink}/Admin/tout-les-seances`, {
            p_email : 0 ,
        })
        .then(function (response) {
          const countByDate = Object.values(
            response.data.reduce((acc, item) => {
              if (!acc[item.s_date]) {
                acc[item.s_date] = { id: Object.keys(acc).length + 1, name: item.s_date, value: 0 };
              }
              acc[item.s_date].value += 1;
              return acc;
            }, {})
          );

          setEvolutionChart(countByDate)
          console.log(countByDate)
          

          let mchrt = []
          GConf.matiereListe.map((data) => mchrt.push({ name: data.nom, value: response.data.filter(item => item.s_matiere === data.nom).length }))
          setMatiereChart(mchrt)

          let gchrt = []
          GConf.groupeListe.map((data) => gchrt.push({ name: `${data.spec} - ${data.grp}` , value: response.data.filter(item => item.s_groupe == data.grid).length }))
          setGroupeChart(gchrt)

          let allS = [];
          response.data.map((data,index) => allS.push([
                data.ids,
                data.s_date,
                data.s_temps,
                data.s_matiere,
                data.s_proff,
                //data.s_groupe,
                 _(( (g) => g ? `${g.spec} - ${g.grp}` : '' )(GConf.groupeListe.find(g => g.grid == data.s_groupe))),
                _(<span className={`badge bg-${data.s_etat === 'Ouvert' ? 'success': 'danger'}`}> {data.s_etat} </span>),
                data.s_statistique ? _(`${data.s_statistique} % `) : '',
                _(<Button className='rounded-pill bg-info text-white' size='mini' onClick={ (e) => ShowSeanceListe('showL', data)}><span className='bi bi-list-columns-reverse'></span> </Button>),
          ],))
          setSeanceListe(allS)

        }) 

    },[])

    /*#########################[Function]###########################*/
    const logOutInput = () =>{    
        localStorage.clear();
        window.location.href = "/User";
    }

    const ShowSeanceListe = (genre,data) => {
        setSeanceData(data)
        OpenBottomSheetFunction(genre);
    }

    const OpenBottomSheetFunction = (genre) => {
        setSheetActiveIndex(genre)
        setOpenD(!openD)
    }
    
    /*#########################[Card]###########################*/
    const MainTopCard = () =>{
        return(<>
            <div className='card p-3 fixed-top border-0 shadow-sm  rounded-0'>
                <div className='row'>
                    <div className='col-4 align-self-center'>
                        <NavLink exact='true' to='/'>
                            <span className='bi bi-arrow-left-short bi-md text-primary'></span>
                        </NavLink>

                    </div>
                    <div className='col-8 align-self-center text-end' ><h2> <span className="badge bg-info"> <span className='bi bi-building '></span>  Administration </span></h2></div>
                    
                </div>
            </div>
        </>)
    }

    const CustomTabs = () => {
      return(<>
        <div className='row mb-3'>
          <div className='col-12 col-lg-10 align-self-center' >
            <div style={{width:'100%', overflowX: 'auto', overflowY : 'hidden',  whiteSpace:'nowrap'}}>
              <Menu secondary >
                  <Menu.Item active={activeIndex == 0} className='rounded-pill' onClick={ () => setActiveIndex(0)}>
                    <span className='text ' style={{color: '#880a94'}}>
                      <b>
                        <span className='bi bi-pie-chart-fill'></span> Stat Generales  
                      </b>
                    </span>
                  </Menu.Item>
                  <Menu.Item active={activeIndex == 1} className='rounded-pill' onClick={ () => setActiveIndex(1)}>
                    <span className='text ' style={{color: '#00b8e6'}}>
                      <b>
                        <span className='bi bi-person'></span> Listes des Proff 
                      </b>
                    </span>
                  </Menu.Item>
                  <Menu.Item active={activeIndex == 2} className='rounded-pill' onClick={ () => setActiveIndex(2)}>
                    <span className='text' style={{color: '#e69500'}}>
                      <b>
                        <span className='bi bi-people'></span> Liste des Etudiant 
                      </b>
                    </span>
                  </Menu.Item>
                  <Menu.Item active={activeIndex == 3} className='rounded-pill' onClick={ () => setActiveIndex(3)}>
                    <span className='text' style={{color: '#006be6'}}>
                      <b>
                        <span className='bi bi-clock-history'></span> Liste des Seances 
                      </b>
                    </span>
                  </Menu.Item> 
                 {/* <Menu.Item active={activeIndex == 4} className='rounded-pill' onClick={ () => setActiveIndex(4)}>
                    <span className='text' style={{color: '#4e4d4b'}}>
                      <b>
                        <span className='bi bi-person-circle'></span> Mon Profile
                      </b>
                    </span>
                  </Menu.Item> */}
                   
              </Menu>
            </div>
          </div>
          <div className='col-4 text-end'>
              {/* <Button icon='calendar alternate' className='rounded-pill bg-system-btn me-4' onClick={() => openEditModal('justOpen',true)} /> */}
              {/* <MainSubNavCard text='Calendrier' link='rq/calendrier' icon='calendar-week' /> */}
          </div>
        </div>
      </>)
    }

    const StatCard = () => {
      return(<>
        <>
            <div className='card card-body border-div shadow-sm mb-3'>
                <div className='row'>
                  <div className='col-12'>
                    <Button onClick={() => document.getElementById('printRapport').contentWindow.window.print()} style={{backgroundColor: "#027a8f"}} className='rounded w-auto text-white'  > <span className='bi bi-printer-fill'></span> Imprimer Rapport de Presence   </Button>  
                    <Button onClick={() => setSheetActiveIndex('Add')} style={{backgroundColor: "#cf9b0c"}} className='rounded w-auto text-white'  > <span className='bi bi-bar-chart-line'></span> Metre a jour les Stat  </Button>  
                  </div>
                </div>
            </div>
            <div className='row'>
              <div className='col-12 col-lg-8'>
                <div className='card card-body border-div shadow-sm mb-3'>
                    evolution des seances
                    <ResponsiveContainer width="100%" height={220} >
                          <AreaChart
                              width={200}
                              height={60}
                              data={evolutionSChart}
                              margin={{ top: 20, right: 0, left: 0, bottom: 0, }}
                          >
                          <defs>
                              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                  <stop offset="5%" stopColor={GConf.themeColor} stopOpacity={0.8}/>
                                  <stop offset="95%" stopColor={GConf.themeColor} stopOpacity={0}/>
                              </linearGradient>
                          </defs>
                              <Tooltip />
                                  <Area type="monotone" dataKey="value" stroke={GConf.themeColor} strokeWidth={3} fill="url(#colorUv)" />
                                  <XAxis hide  dataKey="name" />
                                  <YAxis hide domain={[0, (Math.max(...evolutionSChart.map(o => o.value)) + 1)]} />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
              </div>

              <div className='col-12 col-lg-4'>
                <div className='card card-body border-div shadow-sm mb-3'>
                      centre d'impression 
                      <PieChart width={350} height={200} >
                        <Pie
                          data={matiereChart}
                          cx={150}
                          cy={100}
                          innerRadius={0}
                          outerRadius={80}
                          fill="#8884d8"
                          paddingAngle={2}
                          dataKey="value"
                        >
                          {matiereChart.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                </div>
              </div>

              <div className='col-12 col-lg-6'>
                <div className='card card-body border-div shadow-sm mb-3'>
                  presences des matiere
                      <PieChart width={500} height={200} >
                        <Pie
                          data={matiereChart}
                          cx={250}
                          cy={100}
                          innerRadius={60}
                          outerRadius={80}
                          fill="#8884d8"
                          paddingAngle={2}
                          dataKey="value"
                        >
                          {matiereChart.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                </div>
              </div>
              <div className='col-12 col-lg-6'>
                <div className='card card-body border-div shadow-sm mb-3'>
                  pourcentage des presences des groupes
                  <PieChart width={500} height={200} >
                        <Pie
                          data={groupeChart}
                          cx={250}
                          cy={100}
                          innerRadius={60}
                          outerRadius={80}
                          fill="#8884d8"
                          paddingAngle={2}
                          dataKey="value"
                        >
                          {groupeChart.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                </div>
              </div>
            </div>
        </>
      </>)
    }
    const ProffListeCard = () => {
      return(<>
        <>
          <div className='card card-body border-div shadow-sm mb-3'>
            <div className='row'>
              <div className='col-12'>
                <Button onClick={() => OpenBottomSheetFunction('AddP')} style={{backgroundColor: "#0a6480"}} className='rounded w-auto text-white'  > <span className='bi bi-plus'></span> Ajouter un proff </Button>  
                {/* <Button onClick={() => OpenBottomSheetFunction('Edit')} style={{backgroundColor: "#a0c208"}} className='rounded  text-white'  >  modifier </Button>  
                <Button onClick={() => OpenBottomSheetFunction('Edit')} style={{backgroundColor: "#08b6c2"}} className='rounded  text-white'  > dddA</Button>  */}
              </div>
            </div>
              
             
          </div>
          <TableGrid tableData={profListe} columns={["id","Nom","email","matiere","supp","edit", "info"]} />
        </>
      </>)
    }
    const SeancesListeCard = () => {
      return(<>
        <>
          <TableGrid tableData={seancesListe} columns={["id","Date","Temps", "Matiere","Proff", "Groupe", "Etat","%", "Presence"]} />
        </>
      </>)
    }
    const EtudiantListeCard = () => {
      return(<>
        <>
          <div className='card card-body border-div shadow-sm mb-3'>
            <div className='row'>
              <div className='col-12'>
                <Button onClick={() => OpenBottomSheetFunction('AddE')} style={{backgroundColor: "#03a561"}} className='rounded w-auto text-white'  > <span className="bi bi-plus"></span> Ajouter Etudiant</Button>  
                {/* <Button onClick={() => OpenBottomSheetFunction('Edit')} style={{backgroundColor: "#a0c208"}} className='rounded  text-white'  >  modifier </Button>  
                <Button onClick={() => OpenBottomSheetFunction('Edit')} style={{backgroundColor: "#08b6c2"}} className='rounded  text-white'  > dddA</Button>  */}
              </div>
            </div>
          </div>
          <TableGrid tableData={etudiantListe} columns={["id","Nom","email", "groupe", "Supp", "edit"]} />
        </>
      </>)
    }

    const ShowListeCard = () =>{
      let [prListe, setPrListe] = useState([])
      useEffect(() => {
        axios.post(`${GConf.ApiLink}/proff/seance/select-all-presences`, {
            ids :  seanceData.ids,
        })
        .then(function (response) {
             setPrListe(response.data)
        })
    },[])

      return(<>
          <br /> 
          <h1>{seanceData.s_matiere}</h1>
          <h1>{prListe.length}</h1>
      </>)
    }

    return ( <>
            <MainTopCard />
            <br />                
            <br />                
            <br />                
            <br />   
                   
            <div className='container'>
                 
                <CustomTabs  /> 
                <Tab menu={{ secondary: true }} activeIndex={activeIndex} panes={panesRes}  className='no-menu-tabs mt-2' />
                 
            </div> 
            <BottomSheet style={{ '--rsbs-max-w': '50vw',  '--rsbs-ml': 'auto', '--rsbs-mr': 'auto' }} expandOnContentDrag open={openD}  onDismiss={() => setOpenD(!openD)}  >
                <div className='card-body'>
                    
                    { sheetActiveIndex =='AddP' ?  <AddProffCard />  : <></> }  
                    { sheetActiveIndex =='AddE' ?  <AddEtudiantCard />  : <></> }  
                    { sheetActiveIndex =='showL' ?  <ShowListeCard />  : <></> }  
                    { sheetActiveIndex == 'Edit' ?  <>Add </> : <></> }
                    { sheetActiveIndex == 'Other' ?  <>other </> : <></> }   
                </div>
            </BottomSheet>
            <FrameForPrint frameId='printRapport' src={`/Admin/print-rapport`} />
        </> );
}

export default EtudiantLandingPage;